module.exports = __webpack_public_path__ + "img/icon_reg_3.e6331de4.png";